import styled from 'styled-components';
import { gridSizes, media, weights } from 'utils/style';
import OrderStop from './OrderStop';

export default styled(OrderStop)`
  display: flex;
  justify-content: flex-start;

  svg {
    path {
      fill: var(--grey700);
    }
  }
  &:first-child {
    .prev-step {
      background-color: var(--white);
    }
  }
  &:last-child {
    .step-data-wrapper {
      border: none;
      padding: ${gridSizes('M')} 0;
    }
    .next-step {
      background-color: var(--white);
    }
  }
  .step-data-wrapper {
    line-height: 1.2;
    flex-grow: 1;
    position: relative;
    border-bottom: 1px solid var(--grey-mouse);
    padding: ${gridSizes('M')} 0 32px;
    max-width: 90%;

    ${media.lessThan('small')`
      font-size: 14px;
      padding: ${gridSizes('L')} 0;
      line-height: 1.4;
    `}

    ${media.lessThan('extraSmall')`
      padding: 20px 0;
    `}
  }
  .date {
    color: var(--grey700);
    &:first-letter {
      text-transform: uppercase;
    }
  }
  .name {
    margin: 0;
    font-weight: ${weights('medium')};
    font-size: 20px;
    margin: ${gridSizes('S')} 0;
    ${media.lessThan('small')`
      font-size: ${gridSizes('M')};
      margin: 6px 0;
    `}
  }
  .address {
    color: var(--grey700);
  }
  .load-info-wrapper {
    background: var(--white-caniche);
    border-radius: ${gridSizes('XS')};
    margin: ${gridSizes('M')} 0;
    padding: ${gridSizes('S')};
  }

  .load-info-wrapper-transparent {
    background: transparent;
  }

  .warning {
    font-weight: 500;
    color: var(--orange-peach-text);
  }
  .add-button {
    display: flex;
    align-items: center;
    margin: ${gridSizes('L')} 0 0;
    border-color: var(--grey700);
    color: var(--grey700);
    span {
      font-size: ${gridSizes('M')};
      font-weight: ${weights('regular')};
      margin-left: 4px;
      color: var(--grey700);
      text-decoration: underline;
    }
  }

  .download-button {
    display: inline-block;
    margin: ${gridSizes('S')} 0 0 32px;
    color: var(--grey700);
    padding: 6px 18px 6px ${gridSizes('M')};
    font-size: ${gridSizes('M')};
    appearance: none;
    border-radius: 4px;
    background-color: #f7f8fa;
    border: 1px solid var(--grey300);
    cursor: pointer;
    &:hover {
      text-decoration: none;
      svg {
        fill: var(--grey700);
      }
    }
    div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 100%;
    }
    svg {
      margin: 0;
      color: var(--grey700);
      fill: var(--grey700);
    }
    .label {
      margin-left: ${gridSizes('S')};
      font-weight: ${weights('bold')};
    }

    @media print {
      display: none;
    }
  }

  &:nth-child(2) {
    .prev-step {
      background-color: transparent !important;
    }
  }

  .assigned {
    &__driver {
      align-items: center;
      display: flex;
      color: var(--grey900);
      font-weight: 500;
    }

    &__driver-icon {
      align-items: center;
      display: flex;
      justify-content: center;
      margin-right: 0.8rem;

      svg {
        fill: var(--grey900);
      }
    }

    &__driver-label {
      margin-right: 0.4rem;
    }

    &__vehicle {
      color: var(--grey700);
      font-size: 1.4rem;
      padding-left: 2.6rem;
    }
  }
`;
